export default __webpack_public_path__ + "static/media/icon-search.77f7f939.svg";